<template>
  <div class="skeleton-wrapper" :class="{ 'skeleton-wrapper--dark': dark }">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'SkeletonLoader',
  props: {
    dark: { type: Boolean, default: false }
  }
}
</script>

<style lang="scss">
@keyframes skeleton-shimmer {
  0% { background-position: -200px 0; }
  100% { background-position: calc(200px + 100%) 0; }
}

.skeleton-wrapper {
  .sk-line {
    height: 12px;
    border-radius: 4px;
    background: #e2e8f0;
    background-image: linear-gradient(90deg, #e2e8f0 0px, #f1f5f9 40px, #e2e8f0 80px);
    background-size: 200px 100%;
    animation: skeleton-shimmer 1.5s ease-in-out infinite;
    margin-bottom: 8px;

    &--sm { height: 8px; }
    &--lg { height: 16px; }
    &--xl { height: 24px; }
    &--title { height: 20px; width: 60%; margin-bottom: 12px; }
  }

  .sk-circle {
    border-radius: 50%;
    background: #e2e8f0;
    background-image: linear-gradient(90deg, #e2e8f0 0px, #f1f5f9 40px, #e2e8f0 80px);
    background-size: 200px 100%;
    animation: skeleton-shimmer 1.5s ease-in-out infinite;

    &--sm { width: 24px; height: 24px; }
    &--md { width: 36px; height: 36px; }
    &--lg { width: 48px; height: 48px; }
  }

  .sk-rect {
    border-radius: 6px;
    background: #e2e8f0;
    background-image: linear-gradient(90deg, #e2e8f0 0px, #f1f5f9 40px, #e2e8f0 80px);
    background-size: 200px 100%;
    animation: skeleton-shimmer 1.5s ease-in-out infinite;
  }

  .sk-row {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 16px;
  }

  .sk-col {
    flex: 1;
    min-width: 0;
  }
}

.skeleton-wrapper--dark {
  .sk-line, .sk-circle, .sk-rect {
    background: #334155;
    background-image: linear-gradient(90deg, #334155 0px, #475569 40px, #334155 80px);
    background-size: 200px 100%;
  }
}
</style>
